import styled from 'styled-components';

export default styled.div`
    .page-title {
        font-size: 30px;
        color: ${(props) => props.theme.pageTitleText};
        letter-spacing: 1.7px;
        margin: 20px 0 10px 0;
        font-weight: 400;
        display: flex;
        flex-direction: row;
        width: 90%;
    }

    hr {
        width: calc(100% - 10px);
        outline: none;
        border: none;
        margin: 0 5px;
        border-bottom: 1px solid #efefef;
    }

    .actions-wrapper {
        .button {
            margin: 0;
        }

        margin-top: 10px;
        margin-bottom: 10px;
        display: flex;
        justify-content: flex-end;
        flex-wrap: wrap;
        gap: 10px;
    }

    .details {
        display: flex;
        flex-direction: row;

        .detail {
            display: flex;
            flex-direction: row;
            align-items: center;

            p {
                color: ${(props) => props.theme.homeListRowText};
                font-size: 14px;
            }

            svg {
                color: ${(props) => props.theme.homeListRowText};
                font-size: 10px;
                margin-right: 4px;
                margin-bottom: 2px;
            }
        }
    }

`;